export default{
    en:{
        carousel:{
            article: 'Article',
            book: 'Book',
            conference: 'Academic Activity',
            report: 'Research Report',
            patent: 'Intellectual Property',
            techtrans: 'Tech Transfer',
        },
        shortcut:{
            shortcut: 'Shortcut',
            print: 'Performance Report',
            research: 'Research Achievement',
            teaching: 'Teaching Achievement',
            service: 'Service Achievement',
        }
    },
    ko:{
        carousel:{
            article: '논문',
            book: '저역서',
            conference: '학술활동',
            report: '연구업적',
            patent: '지식재산',
            techtrans: '기술이전',
        },
        shortcut:{
            shortcut: '바로가기',
            print: '보고서 출력',
            research: '연구업적',
            teaching: '교육업적',
            service: '봉사업적',
        }

    }
}